export default interface Coverage {
    id: string;
    agency_name: string;
    username: string;
    pin_code: string;
    pincode_details: {
        area_name: string;
        district: string;
        state_name: string;
    };
    status: CoverageStatus;
    created_date: string;
    updated_date: string;
    created_by: string;
    updated_by: string;
    comment?: string;
}

export enum CoverageStatus {
    PENDING_REVIEW = "PENDING_REVIEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    REMOVED = "REMOVED"
}

export interface CoverageListResponse {
    coverage_entries: Coverage[];
    count: number;
}

export interface CoverageUpdateRequest {
    status: "APPROVED" | "REJECTED";
    comment?: string;
}

export interface CoverageDeleteRequest {
    comment: string;
}
